var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDislike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.42971 8.33333L11.6474 8.33333C12.6516 8.33333 13.3047 7.29025 12.8556 6.40371L10.4916 1.73705C10.2628 1.28534 9.79507 1 9.2834 1L6.56972 0.999999C6.45927 0.999999 6.34924 1.01337 6.24209 1.03981L3.70171 1.66667M8.42971 8.33333L8.42971 11.6667C8.42971 12.403 7.82491 13 7.07885 13L7.01437 13C6.67695 13 6.40342 12.73 6.40342 12.397C6.40342 11.9208 6.26061 11.4552 5.99299 11.059L3.70171 7.66667L3.70171 1.66667M8.42971 8.33333L7.07885 8.33333M3.70171 1.66667L2.35086 1.66667C1.6048 1.66667 1 2.26362 1 3L0.999999 7C0.999999 7.73638 1.6048 8.33333 2.35086 8.33333L4.03943 8.33333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
export default __webpack_public_path__ + "static/media/dislike.226aed613ece7ff0eb5ad35122919330.svg";
export { ForwardRef as ReactComponent };